import React, { FC, memo } from 'react';
import _map from 'lodash/map';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import { useEthicAppearanceOptions } from '@blocs.filter';
import { FilterData } from '../../shared/types';
import { Label, StyledFormikSelectableSearchDropdown } from '../../shared/styles';

type Props = FilterData;

const EthnicAppearance: FC<Props> = ({ name, label }) => {
  const ethnicAppearanceOptions = useEthicAppearanceOptions();

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelectableSearchDropdown saveAsOption name={name}>
        {_map(ethnicAppearanceOptions, (item) => (
          <FormikSelectableSearchDropdown.Option key={item.value} value={item.value} label={item.label} />
        ))}
      </StyledFormikSelectableSearchDropdown>
    </>
  );
};

export default memo(EthnicAppearance);
